// İSG uzmanı portalı — durum → `Tag` rengi yardımcıları (S33-8 review fix #3).
//
// Domain iş kuralı taşıyan eşlemeler (§13/§14.1/§19/§31) kendi enum dosyalarında KALIR —
// `permits/permitEnums.ts` (`getPermitStatusPresentation`, `hazardTagColor`), `contractors/tone.ts`,
// `risk/riskEnums.ts`, `department-review/departmentEnums.ts`: her biri zaten yalnız
// `TagColor` döner ve kendi bağlamının belge referansını taşır — buraya TAŞINMADI, fiziksel
// birleştirme dokümantasyon bağlamını kaybettirirdi.
//
// Bu dosya, doğal bir domain-enum dosyası OLMAYAN (ya da eskiden bir sayfanın kendi yerel
// fonksiyonu/inline üçlü operatörü olarak yaşayan) durum eşlemelerinin TEK yeri:
// - `kioskStatusTagColor` — eskiden `KioskDevicesPage.tsx`'in yerel `statusTagColor`'ı.
// - `activeTagColor` — çok sayıda listede tekrar eden `isActive ? 'green' : 'gray'` üçlü
//   operatörünün (§5.1 "sürüyor, kimse suçlu değil" — Pasif kırmızı DEĞİL, gri) tek kaynağı.

import type { KioskStatus, TagColor } from '@isgportal/shared';

/** Kiosk cihaz durumu (Active/Pending/Disabled — api-contract §5.9): `Active` yeşil,
 * `Disabled` kırmızı (yönetici bilinçli devre dışı bıraktı — `contractorStatusTone` ile aynı
 * desen), `Pending` gri (bekliyor — engellemiyor, sarı yok). */
export function kioskStatusTagColor(status: KioskStatus): TagColor {
  switch (status) {
    case 'Active':
      return 'green';
    case 'Disabled':
      return 'red';
    default:
      return 'gray';
  }
}

/** Basit Aktif/Pasif rozeti (birçok liste — rol/kullanıcı/tür/eğitim): Aktif yeşil, Pasif gri
 * (§5.1 "sürüyor, kimse suçlu değil" — kırmızı DEĞİL, pasifleştirme bir hata durumu değil). */
export function activeTagColor(isActive: boolean): TagColor {
  return isActive ? 'green' : 'gray';
}
